<template>
	<div class="row" :class="changeContainerHeight">
		<card-header title="recover_your_password" />
		<div class="col-12 q-px-lg q-pb-xl container-login">
			<div
				class="row"
				:class="$q.platform.is.desktop ? 'full-height relative-position' : ''"
				v-if="recover_with_username"
			>
				<div class="col-12" :class="$q.platform.is.desktop ? 'absolute-center text-center' : ''">
					<div class="row justify-center q-col-gutter-md">
						<div class="col-12">
							{{
								$t(
									'log_in_to_receive_an_email_with_instructions_and_a_link_to_create_a_new_password'
								)
							}}
						</div>

						<div class="col-xs-12 col-md-7">
							<q-form @submit.prevent="recoverPassword()">
								<div class="row q-col-gutter-md">
									<div class="col-12">
										<q-input
											lower-case
											dense
											v-model="username"
											:label="$t('user')"
											:error="v$.username.$error"
											@input="v$.username.$touch"
											:hint="$t('use_your_email_or_document_to_recover_your_password')"
										/>
									</div>
									<div class="col-12 row justify-center">
										<VueRecaptcha
											class="q-mb-sm"
											@verify="onVerifyRecaptcha"
											@expired="onExpiredRecaptcha"
											:hl="recaptchaLanguage"
											:key="$i18n.locale"
											ref="recaptcha"
											:loadRecaptchaScript="false"
											:sitekey="getSiteKeyRecaptcha"
										></VueRecaptcha>
									</div>
									<div class="col-12">
										<q-btn
											type="submit"
											color="primary"
											:label="$t('recover_password')"
											:class="$q.platform.is.mobile ? 'full-width' : ''"
										/>
										<q-btn
											flat
											color="primary"
											:label="$t('back')"
											@click="backButton()"
											:class="$q.platform.is.mobile ? 'full-width q-mt-sm' : 'q-ml-lg'"
										/>
									</div>
								</div>
							</q-form>

							<div class="row q-col-gutter-md q-mt-xs" v-if="recoverPasswordSms">
								<div class="col-12 text-lowercase" v-if="$q.platform.is.desktop">
									{{ $t('or') }}
								</div>

								<div class="col-12">
									<q-btn
										color="secondary"
										:label="$t('recover_password_with_sms')"
										@click="showRecoverWithSms()"
										:class="$q.platform.is.mobile ? 'full-width' : ''"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				class="row"
				:class="$q.platform.is.desktop ? 'full-height relative-position' : ''"
				v-if="recover_with_sms && !send_recovery_code"
			>
				<div class="col-12" :class="$q.platform.is.desktop ? 'absolute-center text-center' : ''">
					<div class="row justify-center q-col-gutter-md">
						<div class="col-12">
							{{
								$t(
									'enter_your_document_to_receive_an_sms_with_a_verification_code_to_create_a_new_password'
								)
							}}
						</div>

						<div class="col-xs-12 col-md-7">
							<q-form @submit.prevent="recoverSendDocument()">
								<div class="row q-col-gutter-md">
									<div class="col-12">
										<q-input
											lower-case
											dense
											v-model="document"
											:label="$t('document')"
											:error="v$.document.$error"
											:hint="$t('use_only_numbers_ex')"
											@input="hidePhoneFields()"
										/>
									</div>

									<div class="col-12" v-if="!phone_fields">
										<q-btn
											type="submit"
											color="primary"
											:label="$t('recover_password')"
											:class="$q.platform.is.mobile ? 'full-width' : ''"
										/>
									</div>
								</div>
							</q-form>

							<div class="row q-col-gutter-md q-mt-xs" v-if="!phone_fields">
								<div class="col-12 text-lowercase" v-if="$q.platform.is.desktop">
									{{ $t('or') }}
								</div>

								<div class="col-12">
									<q-btn
										color="secondary"
										:label="$t('recover_password_with_username')"
										@click="showRecoverUsername()"
										:class="$q.platform.is.mobile ? 'full-width' : ''"
									/>
								</div>
							</div>

							<div class="row q-col-gutter-md q-mt-xs" v-if="phone_fields">
								<div class="col-12 text-left">
									{{ $t('we_found_the_phone_number') }}
									<strong>{{ partial_phone }}</strong>
									{{ $t('corresponding_to_the_document_informed_above') }}
									{{
										$t(
											'enter_your_phone_number_below_and_press_send_to_receive_a_confirmation_code'
										)
									}}
								</div>

								<div class="col-12">
									<q-form @submit.prevent="requestSmsCode()">
										<div class="row q-col-gutter-md">
											<div class="col-12">
												<q-input
													lower-case
													dense
													v-model="phone"
													:label="$t('phone_number')"
													:error="v$.phone.$error"
													@input="v$.phone.$touch"
													:hint="$t('ddd_plus_number_ex')"
												/>
											</div>

											<div class="col-12">
												<q-btn
													type="submit"
													color="primary"
													:label="$t('request_code_by_sms')"
													:class="$q.platform.is.mobile ? 'full-width' : ''"
												/>
											</div>
										</div>
									</q-form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				class="row"
				:class="$q.platform.is.desktop ? 'full-height relative-position' : ''"
				v-if="send_recovery_code"
			>
				<div class="col-12" :class="$q.platform.is.desktop ? 'absolute-center text-center' : ''">
					<div class="row justify-center q-col-gutter-md">
						<div class="col-12">
							{{ $t('enter_the_code_received_by_sms_to_create_a_new_password') }}
						</div>

						<div class="col-xs-12 col-md-7">
							<q-form @submit.prevent="sendSmsCode()">
								<div class="row q-col-gutter-md">
									<div class="col-12">
										<q-input
											lower-case
											dense
											v-model="code"
											:label="$t('code')"
											:error="v$.code.$error"
											@input="v$.code.$touch"
										/>
									</div>

									<div class="col-12">
										<q-btn
											type="submit"
											color="primary"
											:label="$t('send_code')"
											:class="$q.platform.is.mobile ? 'full-width' : ''"
										/>
									</div>

									<div class="col-12">
										<q-btn
											color="secondary"
											@click="requestNewSmsCode()"
											:disable="disable_to_request_new_sms"
											:class="$q.platform.is.mobile ? 'full-width' : ''"
										>
											<vue-countdown
												v-if="disable_to_request_new_sms"
												@end="countdownEnded()"
												:time="time"
												:emit-events="true"
												v-slot="{ days, hours, minutes, seconds }"
											>
												{{ $t('request_new_sms_code') }} {{ $t('in') }} {{ seconds }}
												{{ $t('seconds') }}
											</vue-countdown>

											<template v-if="!disable_to_request_new_sms">
												{{ $t('request_new_sms_code') }}
											</template>
										</q-btn>
									</div>
								</div>
							</q-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClientLogo from 'components/utils/ClientLogo'
import CardHeader from 'components/login/mobile/CardHeader'

import { requiredIf } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'

export default {
	name: 'RequestPassword',

	props: ['redirect'],

	setup() {
		return { v$: useVuelidate({ $scope: false }) }
	},

	data() {
		return {
			document: '',
			partial_phone: '',
			phone: '',
			phone_fields: false,
			recover_with_sms: false,
			recover_with_username: true,
			user_id: '',
			username: '',
			send_recovery_code: false,
			recaptcha_token: null,
			code: '',
			countdown: false,
			time: 60000,
			disable_to_request_new_sms: false,
			webservice_forgot_password_url: '',
		}
	},

	components: {
		'client-logo': ClientLogo,
		CardHeader,
	},

	computed: {
		...mapGetters({
			login_oauth2: 'params/login_oauth2',
			register: 'params/register',
			use_portfolio_page: 'params/use_portfolio_page',
		}),

		changeContainerHeight() {
			if (this.$q.screen.height < 950) return 'height-80'
			else return 'height-70'
		},

		recoverPasswordSms() {
			return this.register?.recover_password_with_sms
		},

		recaptchaLanguage() {
      const locale = this.$i18n.locale
			const customMap = {
				'pt-BR': 'pt-BR',
				'en-US': 'en',
				'es-ES': 'es',
				'fr-FR': 'fr'
			};
			return customMap[locale] || locale.split('-')[0]
    },

		getSiteKeyRecaptcha() {
			return process.env.GOOGLE_RECAPCHA_KEY
		},
	},

	methods: {
		async recoverPassword() {
			this.v$.$touch()

			if (!this.v$.$error) {
				this.$q.loading.show()

				const data = {
					user_email: this.username,
					recaptcha_token: this.recaptcha_token,
				}

				if (this.redirect) data.redirect_to = this.redirect

				const url = this.webservice_forgot_password_url
					? this.webservice_forgot_password_url
					: '/etraining_login/api_recover_password/'

				this.$axios
					.post(url, data)
					.then((response) => {
						if (this.webservice_forgot_password_url) {
							if (response.data.webcrawler?.result) {
								this.$q.notify({
									message: response.data.webcrawler.message,
									type: 'positive',
									icon: 'fal fa-check',
									progress: true,
								})
							}
						} else {
							this.$q.notify({
								message: `${this.$t('an_email_has_been_sent_to')} ${response.data.email}. ${this.$t(
									'check_your_email_for_password_recovery_instructions'
								)}`,
								type: 'positive',
								icon: 'fal fa-check',
								progress: true,
							})
						}

						if (!this.use_portfolio_page) this.$router.push({ name: 'login' })
						else this.$router.push({ name: 'portfolio' })
					})
					.catch((e) => {
						this.$q.notify({
							message: this.$t(
								'the_informed_user_could_not_be_found_please_check_the_data_provided'
							),
							type: 'negative',
							icon: 'fal fa-ban',
						})

						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		onVerifyRecaptcha(token) {
			this.recaptcha_token = token
		},

		onExpiredRecaptcha() {
			this.recaptcha_token = null
		},

		showRecoverWithSms() {
			this.v$.$reset()
			this.recover_with_username = false
			this.recover_with_sms = true
		},

		showRecoverUsername() {
			this.v$.$reset()
			this.recover_with_username = true
			this.recover_with_sms = false
		},

		recoverSendDocument() {
			this.v$.$touch()

			if (!this.v$.$error) {
				this.$q.loading.show()

				const data = {
					document: this.document,
				}

				this.$axios
					.post('/etraining_login/get_phone_number_with_document/', data)
					.then((response) => {
						this.phone_fields = true
						this.partial_phone = response.data.phone
						this.user_id = response.data.user_id
						this.phone = ''
						this.v$.$reset()
					})
					.catch((e) => {
						let error_message =
							'the_informed_user_could_not_be_found_please_check_the_data_provided'
						if (e.response.data.hasOwnProperty('phone_not_found'))
							error_message = 'there_is_no_registered_phone_for_this_user'

						this.$q.notify({
							message: this.$t(error_message),
							type: 'negative',
							icon: 'fal fa-ban',
						})

						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		requestSmsCode() {
			this.v$.$touch()

			if (!this.v$.$error) {
				this.$q.loading.show()

				const data = {
					phone: this.phone,
					user_id: this.user_id,
				}

				this.$axios
					.post('/etraining_login/send_code_by_sms/', data)
					.then((response) => {
						this.send_recovery_code = true
						this.countdown = true
						this.time = 60000
						this.disable_to_request_new_sms = true
						this.v$.$reset()
					})
					.catch((e) => {
						this.$q.notify({
							message: this.$t('the_number_entered_does_not_correspond_to_the_registered_number'),
							type: 'negative',
							icon: 'fal fa-ban',
						})

						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		requestNewSmsCode() {
			this.send_recovery_code = false
			this.v$.$reset()
			this.requestSmsCode()
		},

		sendSmsCode() {
			this.v$.$touch()

			if (!this.v$.$error) {
				this.$q.loading.show()

				const data = {
					code: this.code,
					user_id: this.user_id,
				}

				this.$axios
					.post('/etraining_login/validate_code_sended_by_sms/', data)
					.then((response) => {
						this.$router.replace({
							name: 'set_password',
							params: {
								username: response.data.username,
								token: response.data.token,
								uidb64: response.data.uidb64,
							},
						})
					})
					.catch((e) => {
						this.$q.notify({
							message: this.$t('the_code_sent_is_not_valid'),
							type: 'negative',
							icon: 'fal fa-ban',
						})

						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		hidePhoneFields() {
			this.phone_fields = false
			this.v$.document.$touch
		},

		countdownEnded() {
			this.disable_to_request_new_sms = false
		},

		backButton() {
			if (!this.use_portfolio_page) this.$router.push({ name: 'login' })
			else this.$router.push({ name: 'portfolio' })
		},
	},

	mounted() {
		if (this.login_oauth2?.length) {
			this.webservice_forgot_password_url = this.login_oauth2[0].forgot_password_url
				? this.login_oauth2[0].forgot_password_url
				: ''
		}
	},

	validations() {
		return {
			username: {
				requiredIf: requiredIf(() => {
					return this.recover_with_username
				}),
			},
			document: {
				requiredIf: requiredIf(() => {
					return this.recover_with_sms && !this.phone_fields && !this.send_recovery_code
				}),
			},
			phone: {
				requiredIf: requiredIf(() => {
					return this.recover_with_sms && this.phone_fields && !this.send_recovery_code
				}),
			},
			code: {
				requiredIf: requiredIf(() => {
					return this.recover_with_sms && this.phone_fields && this.send_recovery_code
				}),
			},
		}
	},
}
</script>

<style lang="scss" scoped>
.container-login {
	margin-top: 5%;
	margin-bottom: 5%;
}
.title {
	display: flex;
	justify-content: center;
}
</style>
